export default function NotFound() {
  return (
    <section className="section">
      <div className="wrap">
        <div className="empty-state">
          <h1>Page not found</h1>
          <p>The page you were looking for isn&apos;t here. It may have moved.</p>
          <a className="btn btn-rust btn-sm" href="/">Go to the home page</a>{' '}
          <a className="btn btn-outline btn-sm" href="/projects">Browse projects</a>
        </div>
      </div>
    </section>
  );
}
